/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 硬盘机品牌
 */
let EnumDiskBank = {
	Dahua: 						new EnumItem('大华 ', 0),
    HIKNew: 						new EnumItem('海康新', 1),
    HIKOld: 						new EnumItem('海康旧', 2),
	...enumMixn
}
export default EnumDiskBank
